
import { Options, Vue } from 'vue-class-component';
import { CourseProduct, Product } from "@/data/products";
import { formatDate, formatPrice } from "@/utils/helpers";
import { PropType } from "vue";

@Options({
    props: {
        product: {
            type: Object as PropType<Product|CourseProduct>,
            required: true,
        },
        enableOrderButton: { // @TODO: refactor naming to "enableActionButton"
            type: Boolean,
            required: false,
            default: false,
        },
        orderButtonLabel: { // @TODO: refactor naming to "actionButtonLabel"
            type: String,
            required: false,
            default: '',
        },
        classes: {
            type: Object,
            required: false,
            default: {},
        },
        applyDiscountPercent: {
            type: Number as PropType<number>,
            required: false,
            default: 0,
        },
        showPrice: {
            type: Boolean,
            required: false,
            default: true,
        },
        showRegion: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    methods: {
        formatDate,
        formatPrice,
    },
    components: {

    },
    emits: [
        'order-button-clicked'
    ],
})
export default class ProductCard extends Vue {
    product!: Product|CourseProduct
    enableOrderButton!: boolean
    classes!: Record<string, boolean>
    applyDiscountPercent!: number

    get generalProduct() : Product { // not pretty but ok
        return this.product as Product;
    }
    get courseProduct() : CourseProduct { // not pretty but ok
        return this.product as CourseProduct;
    }

    durationUnitMapping: Record<string, string[]> = {
        days: ['Tag', 'Tage'],
        months: ['Monat', 'Monate'],
        years: ['Jahr', 'Jahre'],
    }

    expirationHuman(product: Product) : string|null {
        /*if( product.type !== 0 ) {
            return null;
        }*/

        if( typeof this.durationUnitMapping[product.configuration.expiration_unit] === 'undefined' ) {
            return null;
        }

        const value = product.configuration.expiration_value;

        return value + ' ' + this.durationUnitMapping[product.configuration.expiration_unit][value === 1 ? 0 : 1];
    }

    get hasDiscount() {
        return this.applyDiscountPercent > 0;
    }

    get discountedPrice() {
        if( !this.hasDiscount ) {
            return this.product.price;
        }

        // minimum price is capped at 1 cent to avoid "free" orders (system can not handle that at this point of time)
        return Math.max(1, Math.floor(this.product.price * (100.0 - this.applyDiscountPercent) / 100.0));
    }

    onOrderButtonClick() {
        this.$emit('order-button-clicked');
    }

    mounted() {
       //
    }
}
